import { render, staticRenderFns } from "./CalendarEventFullDetailBody.vue?vue&type=template&id=b72fe884&scoped=true"
import script from "./CalendarEventFullDetailBody.vue?vue&type=script&lang=js"
export * from "./CalendarEventFullDetailBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72fe884",
  null
  
)

export default component.exports